var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagCircleJp = function SvgFlagCircleJp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 19.75c5.385 0 9.75-4.365 9.75-9.75S15.385.25 10 .25.25 4.615.25 10s4.365 9.75 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M10 .5c5.24 0 9.5 4.26 9.5 9.5s-4.26 9.5-9.5 9.5S.5 15.24.5 10 4.76.5 10 .5m0-.5C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE0026",
    d: "M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
  })));
};
export default SvgFlagCircleJp;